import React from 'react'
import PropTypes from 'prop-types'
import FilterDateRangeV2 from "./FilterDateRangeV2"
import FilterProductType from "./FilterProductType"
import SelectFilterOptions from "../../../shared/SelectFilterOptions"
import { ERROR_TYPE, ERROR_STYLE } from '../../../../helpers/ListOptions.json'
import moment from 'moment'

ItemColorSystemFilters.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    onChangeDate: PropTypes.func.isRequired,
    onChangeProductType: PropTypes.func.isRequired
}

function ItemColorSystemFilters(props) {
    const {filters, onChangeProductType} = props

    function _handleChangeField(field, value) {
        const {onChangeInput} = props

        if (typeof onChangeInput === 'function') {
            onChangeInput(field, value.trim())
        }
    }

    function _handleChangeDate(field, value) {
        const {onChangeDate} = props
        const cloneFilter = Object.assign({}, props.filters)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        if (typeof onChangeDate === 'function') {
            onChangeDate(cloneFilter)
        }
    }

    return (
        <div className='ItemColorSystemFilters'>
            <div className='row align-items-end'>
                {/* <div className='col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={filters.error_type}
                        style={{width: '100%'}}
                        listOptions={ERROR_TYPE}
                        field="error_type" label="Loại lỗi"
                        handleChange={_handleChangeField}
                    />
                </div> */}

                <div className='col-12 col-xl-4 mb-3'>
                    <label className="font-weight-bold">Loại sản phẩm</label>
                    <FilterProductType
                        productTypes={filters.product_types}
                        onChangeProductType={onChangeProductType}
                    />
                </div>

                <div className='col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={filters.error_style || 'all'}
                        style={{width: '100%'}}
                        listOptions={ERROR_STYLE}
                        field="error_style" label="Kiểu lỗi"
                        handleChange={_handleChangeField}
                    />
                </div>

                <div className='col-12 col-xl-3 mb-3'>
                    <label className="font-weight-bold">Ngày báo lỗi</label>
                    <FilterDateRangeV2 
                        field='error_date'
                        ranges={{
                            'Today': [moment().startOf('day'), moment()],
                            'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment()],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}
                        onDatesChange={_handleChangeDate} 
                        format="DD/MM/YYYY HH:mm" 
                        showTime={{ format: 'HH:mm' }}
                    />
                </div>

                <div className='col-12 col-xl-3 mb-3'>
                    <label className="font-weight-bold">Ngày tạo lô</label>
                    <FilterDateRangeV2 field='created_at' onDatesChange={_handleChangeDate}/>
                </div>
            </div>
        </div>
    )
}

export default ItemColorSystemFilters